<template>
    <div class="fabu-tuiguang-page">
        <!-- 顶部Header组件 -->
        <Header :activeName="'8'" :home="false" />

        <div class="content-wrapper">
            <!-- 面包屑导航 -->
            <div class="breadcrumb">
                <el-breadcrumb separator-class="el-icon-arrow-right">
                    <el-breadcrumb-item :to="{ name: 'home' }">首页</el-breadcrumb-item>
                     <el-breadcrumb-item :to="{
                        name: 'home', params: {
                            activeName: '8',
                        },
                    }">商家推广</el-breadcrumb-item>
                    <el-breadcrumb-item>发布推广</el-breadcrumb-item>
                </el-breadcrumb>
            </div>

            <!-- 发布推广内容区域 -->
            <div class="tuiguang-content">


                <el-card shadow="hover" class="tuiguang-card">
                    <div class="tuiguang-title">
                        <div class="title-desc"></div>

                        <span class="title-label">发布推广</span>
                    </div>
                    <el-form :model="tuiguangInfo" :rules="rules" ref="tuiguangForm" class="tuiguang-form">
                        <!-- 推广标题 -->
                        <el-form-item label="推广标题" prop="title" class="form-item">
                            <el-input v-model="tuiguangInfo.title" placeholder="请输入商品标题、特色、卖点" class="title-input" />
                        </el-form-item>
                        <!-- 商品分类 -->
                        <el-form-item label="商品分类" prop="category" class="form-item flex-style">
                            <el-select v-model="tuiguangInfo.category" placeholder="请选择商品分类" style="width: 200px;">
                                <el-option v-for="category in categories" :key="category.aid" :label="category.name"
                                    :value="category.aid"></el-option>
                            </el-select>
                        </el-form-item>
                        <!-- 商品详情 -->
                        <el-form-item label="商品详情" prop="content" class="form-item flex-style">
                            <div class="editor-container">
                                <!-- <quill-editor v-model="tuiguangInfo.content" class="editor"></quill-editor> -->
                                <quill-editor v-model="tuiguangInfo.content" ref="myQuillEditor" :options="editorOption"
                                    class="editor" @blur="onEditorBlur" @focus="onEditorFocus"
                                    @change="onEditorChange"></quill-editor>
                            </div>
                        </el-form-item>

                        <!-- 活动图片 -->
                        <el-form-item label="图片" prop="images" class="form-item flex-style">
                            <ImageUpload :memberId="'13759'" :maxFiles="6" uploadText="上传图片"
                                @upload-success="handleImageSuccess" />
                        </el-form-item>

                        <!-- 推广日期 -->
                        <el-form-item label="推广日期" prop="date" class="form-item flex-style">
                            <el-date-picker v-model="tuiguangInfo.date" type="date" placeholder="请选择推广日期"
                                format="yyyy-MM-dd" value-format="yyyy-MM-dd" class="date-picker"
                                :disabled-date="disabledDate" style="width: 200px;" @change="getZhidingTime" />
                        </el-form-item>

                        <!-- 置顶推广 -->
                        <el-form-item label="置顶推广" prop="topType" class="form-item flex-style" v-if="tuiguangInfo.date">
                            <el-radio-group v-model="tuiguangInfo.topType" class="radio-group"
                                @change="handleTopTypeChange">
                                <!-- <el-radio :label="0">不置顶</el-radio> -->
                                <el-radio :label="item.aid" v-for="(item, index) in zhidingTimes">{{ item.name }}
                                    <span v-if="item.aid != 0">(剩余 {{
                                        item.remaining_top_position }} 置顶位)</span> </el-radio>
                            </el-radio-group>
                            <div class="top-tip" v-if="tuiguangInfo.topType !== '0'">
                                <i class="el-icon-info"></i>
                                <span>置顶推广可提高商品曝光率，费用：¥{{ price }}/天</span>
                            </div>
                        </el-form-item>

                        <!-- 提交按钮 -->
                        <el-form-item class="submit-section">
                            <el-button type="primary" class="submit-btn" @click="submitTuiguang"
                                :loading="isSubmitting">
                                {{ isSubmitting ? '发布中...' : '¥' + price + ' 确认发布' }}
                            </el-button>
                        </el-form-item>
                    </el-form>
                </el-card>
            </div>
        </div>

        <!-- 底部Footer组件 -->
        <Footer />
    </div>
</template>

<script>
// 导入Header和Footer组件
import Header from '../../components/Header.vue'
import Footer from '../../components/Footer.vue'
import ImageUpload from '../../components/ImageUpload.vue'
// 导入富文本编辑器组件和样式
import { quillEditor } from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

export default {
    name: 'FabuTuiguangPage',
    components: {
        Header,
        Footer,
        quillEditor,
        ImageUpload
    },
    data() {
        return {
            // 推广信息数据
            tuiguangInfo: {
                title: '',
                content: '',
                date: '',
                topType: '0',
                images: [],
            },
            categories: [],
            zhidingTimes: [],
            // 选中的置顶推广数据
            selectedTopItem: null,
            price: '0',
            // 编辑器配置项
            editorOption: {
                // 主题：snow（默认，带边框）/ bubble（气泡）
                theme: 'snow',
                placeholder: '添加内容来描述一下商品吧！',
                // 工具栏配置（按需自定义）
                modules: {
                    toolbar: [
                        ['bold', 'italic', 'underline', 'strike'], // 加粗、斜体、下划线、删除线
                        ['blockquote', 'code-block'], // 块引用、代码块
                        [{ 'header': 1 }, { 'header': 2 }], // 标题
                        [{ 'list': 'ordered' }, { 'list': 'bullet' }], // 有序/无序列表
                        [{ 'align': [] }], // 对齐方式

                        [{ 'size': ['small', false, 'large', 'huge'] }], // 字体大小
                        [{ 'color': [] }, { 'background': [] }], // 字体颜色、背景色
                        ['clean'] // 清除格式
                    ]
                },
                // 编辑器初始高度
                height: 300
            },

            // 表单验证规则
            rules: {
                title: [
                    { required: true, message: '请输入推广标题', trigger: 'blur' },
                    { min: 1, max: 50, message: '标题长度在 1 到 50 个字符', trigger: 'blur' }
                ],
                content: [
                    { required: true, message: '请输入商品详情', trigger: 'blur' },
                    { min: 5, message: '详情内容不少于 5 个字符', trigger: 'blur' }
                ],
                date: [
                    { required: true, message: '请选择推广日期', trigger: 'change' }
                ],
                category: [
                    { required: true, message: '请选择商品分类', trigger: 'change' }
                ],
            },
            // 提交状态
            isSubmitting: false,


        }
    },
    mounted() {
        // 默认设置当前日期
        // const today = new Date()
        // const formattedDate = today.getFullYear() + '-' +
        //     String(today.getMonth() + 1).padStart(2, '0') + '-' +
        //     String(today.getDate()).padStart(2, '0')
        // this.tuiguangInfo.date = formattedDate
        this.getHomeTabs()


    },

    computed: {
        userInfo() {
            return this.$store.state.userInfo
        },
        cityCode() {
            return this.$store.state.cityCode[1]
        },
    },
    methods: {
        // 新增：处理置顶推广类型变化事件
        handleTopTypeChange(topType) {
            // 根据选中的topType找到对应的item数据
            this.selectedTopItem = this.zhidingTimes.find(item => item.aid === topType)
            console.log('选中的置顶推广数据:', this.selectedTopItem)
            this.price = this.selectedTopItem ? this.selectedTopItem.price : '0'
            // 可以在这里添加其他需要的逻辑处理
        },

        // 编辑器失焦
        onEditorBlur() {
            // console.log('编辑器失焦')
        },
        // 编辑器聚焦
        onEditorFocus() {
            // console.log('编辑器聚焦')
        },
        // 编辑器内容变化
        onEditorChange(val) {
            // console.log('内容变化：', val.html) // val.html 是带标签的富文本内容
        },
        // 获取编辑器内容
        getContent() {
            // this.$message.success('内容已获取：' + this.content)
            // console.log('最终富文本内容：', this.content)
        },
        // 清空编辑器内容
        clearContent() {
            this.content = ''
        },

        // 图片上传成功回调，接收上传后的图片URL数组
        handleImageSuccess(urls) {
            this.tuiguangInfo.images = urls || []
        },

        // 禁用过去的日期
        disabledDate(time) {
            return time.getTime() < Date.now() - 8.64e7
        },


        // 获取顶部分类数据
        getHomeTabs() {
            this.$api.getHomeTabs().then(res => {
                // console.log(res, 'res');
                let list = res;
                this.categories = list;

            }).catch(err => {
                this.$message.error(err);

            })
        },

        // 获取置顶时间
        getZhidingTime() {
            let data = {
                promotion_date: this.tuiguangInfo.date,
            }
            this.$api.getZhidingTime(data).then(res => {
                // console.log(res, 'res');
                let list = res;
                this.zhidingTimes = list;
                this.zhidingTimes.unshift({
                    name: '不置顶',
                    price: '0',
                    aid: '0'
                })

            }).catch(err => {
                this.$message.error(err);

            })
        },

        // 提交推广信息
        submitTuiguang() {
            this.$refs.tuiguangForm.validate((valid) => {
                if (valid) {
                    this.isSubmitting = true

                    // 提交数据
                    let data = {
                        title: this.tuiguangInfo.title,
                        product_details: this.tuiguangInfo.content,
                        promotion_date: this.tuiguangInfo.date,
                        goodscategory_id: this.tuiguangInfo.category,
                        freetoptime_id: this.tuiguangInfo.topType,
                        usermerchant_id: this.userInfo.user_merchant_id,
                        region_code: this.cityCode,
                        thumb: this.tuiguangInfo.images.join(','),
                    }
                    this.$dapi.publishTuiguang(data).then(res => {
                        let info = res
                        if (this.price == 0) {
                            // 跳转发布成功页面
                            this.$message.success('发布成功')
                            this.$router.push({ name: 'home' })
                        } else {
                            // 跳转支付页面
                            this.$router.push({
                                name: 'Payment', // 用 name 跳转，而非 path
                                params: {
                                    time: info.last_time,
                                    money: this.price,
                                    order_type: 3,
                                    order_config_id: 16,
                                    is_from: 2,
                                },
                                // 如需保留 query 参数，可加 query
                                query: { order_sn: info.order_sn, is_from: 2 }
                            });

                        }

                    }).catch(err => {
                        this.$message.error(err);

                    })


                } else {
                    this.$message.error('请完善推广信息')
                    return false
                }
            })
        }
    }
}
</script>

<style scoped>
.fabu-tuiguang-page {
    min-height: 100vh;
    background-color: #f5f7fa;
}

.content-wrapper {
    max-width: 1200px;
    margin: 0 auto;
    padding: 20px;
}

.breadcrumb {
    padding: 24px 0 20px 0;
}

/* 发布推广内容区域样式 */
.tuiguang-content {
    margin-bottom: 40px;
}

.tuiguang-title {
    margin-bottom: 20px;
    padding-bottom: 15px;
    border-bottom: 1px solid #eee;
    background-color: #fff;
    text-align: left;
    display: flex;
    align-items: center;
}

.title-label {
    font-size: 22px;
    font-weight: bold;
    color: #333;
    margin-right: 15px;
}

.title-desc {
    width: 4px;
    height: 18px;
    background: #286CED;
    border-radius: 0px 0px 0px 0px;
    margin-right: 16px;
}

.tuiguang-card {
    border-radius: 8px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);
}

/* 表单样式 */
.tuiguang-form {
    max-width: 800px;
}

.form-item {
    margin-bottom: 25px;
}

.flex-style {
    display: flex;
    flex-direction: column;
    align-items: start;
}

.title-input {
    width: 100%;
}

/* 图片上传区域样式 */
.image-upload {
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 10px;
}

.uploaded-image {
    position: relative;
    margin-right: 15px;
    margin-bottom: 15px;
    border-radius: 4px;
    overflow: hidden;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.uploaded-image img {
    width: 120px;
    height: 120px;
    object-fit: cover;
    border-radius: 4px;
}

.delete-image-btn {
    position: absolute;
    top: 0;
    right: 0;
    background-color: rgba(255, 255, 255, 0.9);
    border-radius: 0 0 0 4px;
    padding: 2px 6px;
}

.add-image-btn {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 120px;
    height: 120px;
    border: 1px dashed #d9d9d9;
    border-radius: 4px;
    cursor: pointer;
    transition: all 0.3s;
    color: #999;
}

.add-image-btn:hover {
    border-color: #409eff;
    color: #409eff;
}

.add-image-btn i {
    font-size: 24px;
    margin-bottom: 5px;
}

.image-tip {
    font-size: 12px;
    color: #999;
    margin-top: 5px;
}

/* 编辑器样式 */
.editor-container {
    border: 1px solid #d9d9d9;
    border-radius: 4px;
    overflow: hidden;
    width: 100%;
}

.editor {
    /* min-height: 300px; */
    width: 1000px;
}

.editor-toolbar {
    background-color: #f5f5f5;
    padding: 10px;
    border-bottom: 1px solid #d9d9d9;
}

.toolbar-icon {
    font-family: 'Arial Unicode MS', sans-serif;
}

.content-textarea {
    width: 100%;
    border: none;
    resize: vertical;
}

.content-textarea:focus {
    outline: none;
}

/* 单选按钮组样式 */
.radio-group {
    display: flex;
    /* flex-direction: column; */
}

.radio-group .el-radio {
    margin-bottom: 10px;
}

.top-tip {
    margin-top: 10px;
    padding: 8px 12px;
    background-color: #ecf5ff;
    border-radius: 4px;
    font-size: 12px;
    color: #409eff;
    display: flex;
    align-items: center;
}

.top-tip i {
    margin-right: 5px;
}

/* 提交按钮样式 */
.submit-section {
    margin-top: 40px;
    text-align: center;
}

.submit-btn {
    width: 220px;
    height: 48px;
    font-size: 16px;
    background-color: #286CED;
    border: none;
    border-radius: 4px;
}

.submit-btn:hover {
    background-color: #407bff;
}

/* 响应式设计 */
@media (max-width: 768px) {
    .content-wrapper {
        padding: 10px;
    }

    .tuiguang-card {
        padding: 15px;
    }

    .tuiguang-title {
        text-align: center;
    }

    .image-upload {
        justify-content: center;
    }

    .uploaded-image {
        margin-right: 10px;
        margin-bottom: 10px;
    }

    .uploaded-image img {
        width: 100px;
        height: 100px;
    }

    .add-image-btn {
        width: 100px;
        height: 100px;
    }

    .submit-btn {
        width: 100%;
    }
}
</style>